module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-driver-reservation-request"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('dropdown', {
    attrs: {
      "icon": 'fa fa-ellipsis-v fa-2x action',
      "position": 'bottom'
    }
  }, [_c('DriverReservationRequestButtons', {
    attrs: {
      "item": _vm.item
    }
  })], 1)], 1), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("DRR" + _vm._s(_vm.item.id)), _c('driver', {
    attrs: {
      "type": 'onlyname',
      "item": _vm.item.driver
    }
  })], 1), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Start")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.start))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("End")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.end))])])])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Passengers")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.flags.passengers))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Request Completed")]), _c('div', {
    staticClass: "value"
  }, [_c('span', {
    staticClass: "fa",
    class: {
      "fa-times": _vm.item.reservation == null, "fa-check": _vm.item.reservation != null
    }
  }), (_vm.item.reservation !== null) ? void 0 : _vm._e()], 2)])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column shrink"
  }, [_c('label', [_vm._v("Off road")]), _c('div', {
    staticClass: "value"
  }, [_c('span', {
    staticClass: "fa",
    class: {
      "fa-times": !_vm.item.flags.offroad, "fa-check": _vm.item.flags.offroad
    }
  })])]), _c('div', {
    staticClass: "column shrink"
  }, [(_vm.item.flags.hasOwnProperty('luxury')) ? [_c('label', [_vm._v("Luxury")]), _c('div', {
    staticClass: "value"
  }, [_c('span', {
    staticClass: "fa",
    class: {
      "fa-times": !_vm.item.flags.luxury, "fa-check": _vm.item.flags.luxury
    }
  })])] : _vm._e()], 2)])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Pickup")]), _c('div', {
    staticClass: "value"
  }, [_vm._v("PL" + _vm._s(_vm.item.pick_up.id) + " " + _vm._s(_vm.item.pick_up.name))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Dropoff")]), _c('div', {
    staticClass: "value"
  }, [_vm._v("PL" + _vm._s(_vm.item.drop_off.id) + " " + _vm._s(_vm.item.drop_off.name))]), (_vm.item.flags.hasOwnProperty('estimated_distance')) ? [_c('label', [_vm._v("Estimated distance")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.flags.estimated_distance))])] : _vm._e()], 2)])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Status")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.status))]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.sub_status))])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Request Date and Time")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.created_at))]), _c('div', {
    staticClass: "label"
  }, [_vm._v("Request last update")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.updated_at))])])]), (_vm.item.deleted_at != null) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Request deleted at")]), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.item.deleted_at))])])]) : _vm._e()]), _c('div', {
    staticClass: "column shrink"
  }, [(_vm.item.reservation != null) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'reservation',
        params: {
          id: _vm.item.reservation.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })]) : _vm._e()], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20505de2!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/DriverReservationRequest.vue
// module id = 2327
// module chunks = 1